import React from "react";
import "./SeperateHero.css";

const SeperateHero = () => {
  return (
    <div className="seperate-hero-section">
      <div className="seperate-content-wrapper">
        <h1 className="seperate-heading">
          Join us in our <span className="seperate-highlight">adventures</span>
        </h1>
        <p className="seperate-paragraph">
          Want to join us? We're actively hiring across the board. Get in touch,
          we would loooove to talk!
        </p>
        <button className="seperate-button">Get in touch</button>
      </div>
    </div>
  );
};

export default SeperateHero;
